import LocalizedStrings from 'react-localization'

export const strings = new LocalizedStrings({
  en: {
    clinicalNameLabel: 'Clinical Name',
    nameLabel: 'Name',
  },
})
